import gtm from './services/gtmEventEmitter';

export { gtm };
